module.exports = __webpack_public_path__ + "img/5.cea71617.png";